import { Inject, Injectable } from '@angular/core';
import { IBleClient, IQConnectBleClient } from './IBleClient';
import { IQConnect } from './IQConnect';
import { IQConnectEmulator } from './IQConnectEmulator';
import { environment } from 'src/environments/environment';
import { BLE_CLIENT } from './ble-client.token';

@Injectable()
//in chrome browse here to enable BLE
//chrome://flags/#enable-web-bluetooth-new-permissions-backend
export class BLEManagerService extends IQConnect {
  constructor(@Inject(BLE_CLIENT) client: IBleClient) {
    super(client);
  }

  getBleClient(): IQConnectEmulator {
    return this.bleClient as IQConnectEmulator;
  }
}

export function bleClientFactory(): IBleClient {
  return environment.enableDeviceEmulator ? new IQConnectEmulator() : new IQConnectBleClient();
}
